module.exports = __webpack_public_path__ + "img/logo-nyu.b9a9744b.png";